import axios from 'axios';
import {globalActions} from '../../store/global-actions';
import {store} from '../../store/global-store';
import _u from '../../shared/utils';
import {CascadeAction} from './cascade-modal-constants'
import {AdvertActionsCommands} from '../../store/advert-actions';
import {modal, questionModal} from '../modals/modals';

const modalQuestionTemplateName = '#modal-question';

const cascadeModalMixin = {
    data(){
        return {
            model: null,
            active: false,
            preventShowModals: true,
        }
    },
    methods: {
        _navigateCascade(actionName) {
            this.close();
            store.commit(AdvertActionsCommands.NavigateCascadeModal, { actionName, model: this.model });
        },
        _subscribeOpen(mutationType) {
            store.subscribe((mutation) => {
                if (mutation.type === mutationType) {
                    this._handleOpenModal(mutation.payload);
                }
            });
        },
        _handleOpenModal(payload) {
            this.active = true;
            this.model = payload;
        },
        async _sendRequest(url) {
            try {
                await axios.post(url);
            }
            catch(error) {
                this._onError(error);
            }
        },
        _onError(result) {
            globalActions.handleAjaxErrors(result.response);
        },
    },
    mounted() {
        if (this.mutationType) {
            this._subscribeOpen(this.mutationType);
        }
    },
};

const modalConfirmAdvertDelete = {
    extends: modal,
    template: modalQuestionTemplateName,
    mixins: [cascadeModalMixin, questionModal],
    data() {
        return {
            mutationType: 'openConfirmAdvertDeleteModal'
        };
    },
    methods: {
        accept() {
            this._navigateCascade(CascadeAction.APPROVE);
        },
    }
};

const confirmDealCompletedModal = {
    extends: modal,
    template: modalQuestionTemplateName,
    mixins: [cascadeModalMixin, questionModal],
    data() {
        return {
            mutationType: 'openConfirmDealCompletedModal',
            cancelText: '',
        };
    },
    methods: {
        accept() {
            this._navigateCascade(CascadeAction.APPROVE);
        },
        cancel() {
            this._navigateCascade(CascadeAction.REJECT);
        },
        _handleOpenModal(payload) {
            this.active = true;
            this.model = payload;
            this.cancelText = this.model.sharingCascadeModal.dealCompleteModalViewModel.dealCompleteRejectActionName;
            this.cancellButtonId = this.model.sharingCascadeModal.dealCompleteModalViewModel.dealCompleteRejectGaId;
        },
    },
};

const shareBannerModal = {
    extends: modal,
    template: '#share-banner-modal',
    mixins: [cascadeModalMixin],
    props: {
        shareSocials: String,
    },
    methods: {
        goNext() {
            this._navigateCascade(CascadeAction.GONEXT);
        },
        imageLoaded() {
            this.imageLoading = false;
        }
    },
    data() {
        return {
            mutationType: 'openShareBannerModal',
            imageLoading: true,
        };
    },
};

const advertHideConfirmModal = {
    extends: modal,
    template: modalQuestionTemplateName,
    mixins: [cascadeModalMixin, questionModal],
    data() {
        return {
            mutationType: 'openAdvertHideConfirmModal',
            closeOnCross: true,
        };
    },
    methods: {
        accept() {
            if (this.acceptFunc) {
                this.acceptFunc();
                this.close();
            }
            else {
                 this._navigateCascade(CascadeAction.APPROVE);
            }
        },
    },
};

const advertSurveyModal = {
    extends: modal,
    template: "#advert-survey-modal",
    mixins: [cascadeModalMixin],
    data() {
        return {
            mutationType: 'openAdvertSurveyModal',
        };
    },
    methods: {
        approve() {
            this._navigateCascade(CascadeAction.APPROVE);
        },
        reject() {
            this._navigateCascade(CascadeAction.REJECT);
        },
    },
};

const advertStatusChangedToDealedModal = {
    extends: modal,
    template: "#advert-status-changed-modal",
    mixins: [cascadeModalMixin],
    data() {
        return {
            mutationType: 'openAdvertStatusChangedToDealedModal',
        };
    },
    methods: {
        async accept() {
            await this._forceReload();
        },
        async close() {
            await this._forceReload();
        },
        async _forceReload() {
            if (this.model.sharingCascadeModal.dealActionUrl) {
                await this._sendRequest(this.model.sharingCascadeModal.dealActionUrl);
            }
            location.reload();
        }
    },
};

const advertStatusChangedToHiddenModal = {
    extends: modal,
    template: "#advert-status-changed-modal",
    mixins: [cascadeModalMixin],
    data() {
        return {
            mutationType: 'openAdvertStatusChangedToHiddenModal',
        };
    },
    methods: {
        async accept() {
            this._forceReload();
        },
        async close() {
            this._forceReload();
        },
        async _forceReload() {
            if (this.model.sharingCascadeModal.hideActionUrl) {
                await this._sendRequest(this.model.sharingCascadeModal.hideActionUrl);
            }

            location.reload();
        }
    },
};

function initCascadeModals(app) {
    app.component('share-banner-modal', shareBannerModal);
    app.component('confirm-deal-completed-modal', confirmDealCompletedModal);
    app.component('advert-survey-modal', advertSurveyModal);

    app.component('advert-status-changed-to-dealed-modal', advertStatusChangedToDealedModal);
    app.component('advert-status-changed-to-hidden-modal', advertStatusChangedToHiddenModal);

    app.component('advert-hide-confirm-modal', advertHideConfirmModal);
    app.component('modal-confirm-advert-delete', modalConfirmAdvertDelete);

    app.component('sold-advert-modal', {
        mixins: [cascadeModalMixin, questionModal],
        extends: modal,
        template: modalQuestionTemplateName,
        methods: {
            accept() {
                this._navigateCascade(CascadeAction.APPROVE);
            },
        },
        data() {
            return {
                mutationType: 'openSoldModal',
                closeOnCross: true,
            };
        },
    });

    app.component('rented-advert-modal', {
        mixins: [cascadeModalMixin, questionModal],
        extends: modal,
        template: modalQuestionTemplateName,
        methods: {
            async accept() {
                await this._sendRequest(this.model.sharingCascadeModal.dealCompleteModalViewModel.rentedHideActionUrl);
                this._forceReload();
            },
            async cancel() {
                await this._sendRequest(this.model.sharingCascadeModal.dealCompleteModalViewModel.rentedLeaveVisibleActionUrl);
                this._forceReload();
            },
            _forceReload() {
                location.reload();
            },
        },
        data() {
            return {
                mutationType: 'openRentedModal'
            };
        },
    });
}

export {
    initCascadeModals,
};
